import Vue from "vue";
const pixelDb = require(`./${_BBVA_CAMP}/pixelDb.js`).default;

const pxRunner = {
  run(pfx, context) {
    if (pfx.indexOf(".") !== -1) {
      let parts = pfx.split(".");
      // Primer parte, el provider
      let provider = pixelDb.providers[parts[0]];
      if (provider) {
        // La segunda parte debería ser la fx, existe ?
        let fx = provider[parts[1]];

        // Si el provider está habilitado, lo ejecuto
        let fxRun = function () {
          // Run fx
          Vue.$log.info("PXI: " + pfx);
          try {
            setTimeout(() => fx(context), 100);
          } catch (e) {
            Vue.$log.error("Error ejecutando fx: " + e);
          }
        };
        if (provider.enabled) {
          fxRun();
        } else {
          // Sino lo envio a la cola
          provider.queue = provider.queue || [];
          provider.queue.push(fxRun);
        }
      } else {
        Vue.$log.error(
          "Error en definición de trigger, el provider no existe: " + pfx
        );
      }
    } else {
      Vue.$log.error("Error en definición de trigger: " + pfx);
    }
  },
  enableProvider(provider, _cb) {
    if (provider.enabled) {
      _cb();
      return;
    }

    if (provider.wait && provider.wait()) {
      provider.loading = false;
      provider.enabled = true;
      if (provider.init) {
        try {
          provider.init();
        } catch (e) {
          Vue.$log.error("Error initializing provider: " + e);
        }
      }
      _cb();
      return;
    }

    if (!provider.loading) {
      provider.loading = true;
      try {
        provider.enable();
      } catch (ep) {
        Vue.$log.error("Error enabling provider: " + ep);
      }
    }

    if (!provider.wait && provider.loading) {
      provider.enabled = true;
    }

    // Call enableProvider again after a timeout
    setTimeout(() => {
      pxRunner.enableProvider(provider, _cb);
    });
  }
};

export default pxRunner;
